module.exports = __webpack_public_path__ + "img/engels.7e1f20ba.png";